const scripts = new Map<string, Promise<void>>();

/** Share pending loads with feature components, and allow retry after a network failure. */
function loadScript(src: string): Promise<void> {
  const existing = scripts.get(src);
  if (existing) return existing;

  const script = document.createElement("script");
  script.src = src;
  script.async = true;
  const ready = new Promise<void>((resolve, reject) => {
    script.onload = () => resolve();
    script.onerror = () => {
      scripts.delete(src);
      script.remove();
      reject(new Error("Could not load an application script"));
    };
  });
  scripts.set(src, ready);
  document.head.appendChild(script);
  return ready;
}

export function loadGoogleMaps(apiKey: string): Promise<void> {
  return loadScript(`https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&libraries=places`);
}

export function loadYoutube(): Promise<void> {
  return loadScript("https://www.youtube.com/iframe_api");
}

export function loadLuzmo(): Promise<void> {
  return loadScript("https://cdn.luzmo.com/js/luzmo-embed/6.3.2/luzmo-embed.min.js");
}
